import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { device } from '../../providers/theme';
import MobileMenu from './Mobile';

const Nav = styled.nav`
  z-index: 1;
  @media ${device.tablet} {
    display: none;
    padding-left: 36px;
    width: 100%;
  }
  @media ${device.mobile} {
    padding: 14px;
  }
`;

const UL = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  @media ${device.tablet} {
    justify-content: flex-start;
  }
`;

const LI = styled.li`
  color: #fff;
  cursor: pointer;
  font-size: 1rem;
  margin: 0;
  @media ${device.smallMobile} {
    margin: 0 4px;
  }

  a {
    padding: 8px 12px;

    @media screen and (max-width: 1240px) {
      padding: 8px;
    }

    @media ${device.mobile} {
      height: 24px;
    }
  }
`;

function Menu() {
  const pages = [
    { name: 'Rødvin', url: '/roedvin', id: 1 },
    { name: 'Hvidvin', url: '/hvidvin', id: 2 },
    { name: 'Rosé', url: '/rose', id: 3 },
    { name: 'Champagne', url: '/champagne', id: 4 },
    { name: 'Mousserende', url: '/mousserende', id: 5 },
    { name: 'Portvin', url: '/portvin', id: 6 },
    { name: 'Dessertvin', url: '/dessertvin', id: 7 }
  ];

  return (
    <>
      <MobileMenu pages={pages} />
      <Nav>
        <UL>
          {pages.map(wine => (
            <LI key={wine.id}>
              <Link activeClassName="active" to={`${wine.url}`}>
                {wine.name}
              </Link>
            </LI>
          ))}
        </UL>
      </Nav>
    </>
  );
}

export default Menu;
